import colors from "@digits-shared/themes/colors"
import { LabelText } from "@digits-shared/themes/typography"
import styled from "styled-components"

export const PanelContainer = styled.div`
  position: relative;
  width: 100%;
  border-radius: 16px;
  background: var(--category-manager-panel-background);
  height: calc(100vh - 72px - 56px - 8px);
  max-height: 740px;
  margin-top: calc(72px + 56px);
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 74px;
    background: var(--category-manager-header-background);
    border-radius: 16px 16px 0 0;
  }
`

export const PanelHeader = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const PanelTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  position: relative;
`

export const PanelSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 16px 16px;
  flex: 1;
  overflow: hidden;
  overflow-y: auto;
`

export const PanelSection = styled.div`
  position: relative;
  background: var(--category-manager-tile-background);
  border-radius: 16px;
  padding: 16px;
`

export const PanelLabel = styled(LabelText)`
  color: ${colors.secondary60};
`

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const InputRow = styled.div`
  display: flex;
  align-items: start;
  gap: 16px;
`

export const PanelFooter = styled.div`
  align-self: flex-end;
  border-radius: 0 0 16px 16px;
  display: flex;
  width: 100%;
  height: 60px;
  padding: 16px;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  border-top: 1px solid ${colors.translucentBlack20};
  background: ${colors.translucentWhite50};
`
